<!--
  Page d'association activité / membre (#1083) : choix du sens de gestion, puis la fiche
  correspondante, qui porte ses blocs, son bandeau d'erreurs et les actions de l'en-tête.
-->
<div class="fiche">
  <div [formGroup]="form" class="fiche-cases" role="radiogroup" aria-labelledby="activite-membre-gerer">
    <span id="activite-membre-gerer">Gérer :</span>
    <label class="cursor">
      <input type="radio" formControlName="affichageMembreActivites" [value]="true" />
      Les activités d'un membre
    </label>
    <label class="cursor">
      <input type="radio" formControlName="affichageMembreActivites" [value]="false" />
      Les membres d'une activité
    </label>
  </div>

  <!-- (dirty)="desactiverFormulaire($event)" retiré (#1083) : ni la sortie ni la méthode n'existent. -->
  @if (form.get('affichageMembreActivites').value) {
    <app-association-membre-activites [membreId]="membreId"></app-association-membre-activites>
  } @else {
    <app-association-activite-membres [activiteId]="activiteId"></app-association-activite-membres>
  }
</div>
